import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Ui from "./components/Ui";
import WorkflowCanvas from "./components/workflow3/WorkflowCanvas";
import FeedbackModal from "./components/base/FeedbackModal";
import Dialog from "./pages/dialog";
import Workflow from "./pages/workflow";
import Meeting from "./pages/meeting";
import Twins from "./pages/twins";
import Compliance from "./pages/compliance";
import Growth from "./pages/growth";
import Retentions from "./pages/retentions";
import Inventory from "./pages/inventory";
import IotRobot from "./pages/iot-robot";
import SetupPage from "./pages/setup/SetupPage";
import NotFoundPage from "./pages/not-found/NotFoundPage";
import { DataState } from "./context/DataProvider";
import toast from "react-hot-toast";
import Login from "./components/auth/Login";
import Register from "./components/auth/Register";
import Projects from "./ProjectsDemo";
import AdminPage from "./pages/admin/AdminPage";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";
import ReportTemplates from "./pages/report-templates/ReportTemplates";
import aripDashboard from "./pages/arip/DashBoard";

const ProtectedRoutes = ({ onLogin, handleStorageChange, onProjectAccess, projectIdToken, userIdToken, isTeamsInitialized }) => {
  const { feedbackModalOpen, setFeedbackModalOpen, theme, justChangedLocalStorageData, setJustChangedLocalStorageData, setUserGoogleId } = DataState(); // Example of context usage

  useEffect(() => {
    if (justChangedLocalStorageData) {
      handleStorageChange();
      setJustChangedLocalStorageData(false);
    }
  }, [justChangedLocalStorageData])

  const handleFeedbackSubmit = () => {
    toast.success("Feedback Sent");
  };


  return (
    <div className="app" data-theme={theme}>
      <Routes>
        <Route path="/" element={<Navigate to="/chat" />} />
        <Route path="/login" element={<Login onLogin={onLogin} isTeamsInitialized={isTeamsInitialized} />} />
        <Route path="/sign-up" element={<Register onLogin={onLogin} />} />
        <Route path="/chat" element={<Ui />} />
        <Route path="/workflow-canvas" element={<WorkflowCanvas />} />
        <Route path="/workflow" element={<Workflow />} />
        <Route path="/projects" element={<Projects userIdToken={userIdToken} onProjectAccess={onProjectAccess} handleStorageChange={handleStorageChange} />} />
        <Route path="/communication" element={<Dialog />} />
        <Route path="/meeting" element={<Meeting />} />
        <Route path="/arip" element={<aripDashboard/>} />
        <Route path="/twins" element={<Twins />} />
        <Route path="/compliance" element={<Compliance />} />
        <Route path="/growth" element={<Growth />} />
        <Route path="/retentions" element={<Retentions />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route path="/iot-robot" element={<IotRobot />} />
        <Route path="/setup" element={<SetupPage />} />
        <Route path="/report-templates" element={<ReportTemplates />} />
        {/* --- CORRECTED ADMIN ROUTE --- */}
        {/* Pass userIdToken to the protected route wrapper */}
        <Route
          path="/admin-control-panel"
          element={
            <ProtectedAdminRoute userIdToken={userIdToken}>
              <AdminPage />
            </ProtectedAdminRoute>
          }
        />
        <Route path="*" element={<NotFoundPage />} />

      </Routes>
      <FeedbackModal
        isOpen={feedbackModalOpen}
        onClose={() => setFeedbackModalOpen(false)}
        onSubmit={handleFeedbackSubmit}
      />
    </div>
  );
};

export default ProtectedRoutes;
